import React from 'react';
import { Paper, Box, Button } from '@mui/material';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ClearAllIcon from '@mui/icons-material/ClearAll';

const StudentInfoBox = ({
  t,
  studentData,
  username,
  points,
  opacity,
  handleEditStudent,
  handleSave,
  currentTab,
  openConfirmDialog,
  setOpenConfirmDialog,
  handleOpacityDecrease,
  handleOpacityIncrease,
  handleMoveUp,
  handleMoveDown,
  handleMoveLeft,
  handleMoveRight,
  handleResetReview,
  clearAllCheckboxes
}) => {
  if (!studentData) {
    return null; // Ili prikažite placeholder
  }
  return (
    <Paper
      elevation={4}
      style={{
        padding: '20px',
        borderRadius: '16px',
        backgroundColor: '#f9f9f9',
        marginLeft: '-30px',
        boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.1)',
        position: 'relative'
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: '20px' }}
      >
        <h3
          style={{
            fontSize: '1.25rem',
            margin: '0',
            color: '#1976D2',
            fontWeight: '500'
          }}
        >
          {t('review.studentInfo')}
        </h3>
        <button
          onClick={handleEditStudent}
          style={{
            fontSize: '12px',
            backgroundColor: '#4caf50',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '4px 10px',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease'
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#388e3c')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#4caf50')}
        >
          {t('review.editStudentInfo')}
        </button>
      </Box>
      <Box
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '20px',
          backgroundColor: '#f0f9ff',
          padding: '10px',
          borderRadius: '12px',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)'
        }}
      >
        <p>
          <strong>{t('review.name')}:</strong> {studentData.name}
        </p>
        <p>
          <strong>{t('review.class')}:</strong> {studentData.class}
        </p>
        <p>
          <strong>{t('review.school')}:</strong> {studentData.school_name}
        </p>
        <p>
          <strong>{t('review.location')}:</strong> {studentData.location_name}
        </p>
        <p>
          <strong>{t('review.professor')}:</strong> {studentData.professor}
        </p>
      </Box>
      <Box
        style={{
          marginTop: '15px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        {/* Status */}
        <Box style={{ flex: 1, marginRight: '10px' }}>
          <label style={{ fontWeight: 'bold', color: '#333' }}>
            {t('review.status')}:
          </label>
          <select
            name="status_of_p"
            id="status_of_p"
            style={{
              marginLeft: '10px',
              padding: '8px',
              fontSize: '14px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              backgroundColor: '#fff',
              color: '#000',
              width: '80%'
            }}
          >
            <option value="radim">{t('review.working')}</option>
            <option value="zavrseno">{t('review.finished')}</option>
          </select>
        </Box>
        {/* Current Viewer */}
        <Box style={{ flex: 1 }}>
          <label
            style={{
              fontWeight: 'bold',
              color: '#333',
              marginRight: '10px'
            }}
          >
            {t('review.currentViewer')}:
          </label>
          <input
            type="text"
            value={username}
            readOnly
            style={{
              padding: '8px',
              fontSize: '14px',
              fontStyle: 'italic',
              border: '1px solid #ccc',
              borderRadius: '4px',
              backgroundColor: '#fff',
              color: '#000',
              width: '80%'
            }}
          />
        </Box>
      </Box>

      {/* Opacity Controls */}
      <Box style={{ marginTop: '20px' }}>
        <label style={{ fontWeight: 'bold', color: '#333' }}>
          {t('review.opacity')}:
        </label>
        <button
          onClick={handleOpacityDecrease}
          style={{
            marginLeft: '10px',
            padding: '8px',
            fontSize: '14px',
            backgroundColor: '#e0e0e0',
            color: '#333',
            borderRadius: '8px',
            cursor: 'pointer',
            border: 'none',
            transition: 'background-color 0.3s ease'
          }}
        >
          -
        </button>
        <button
          onClick={handleOpacityIncrease}
          style={{
            marginLeft: '5px',
            padding: '8px',
            fontSize: '14px',
            backgroundColor: '#4caf50',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
            border: 'none',
            transition: 'background-color 0.3s ease'
          }}
        >
          +
        </button>
        <span
          style={{
            marginLeft: '10px',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#333'
          }}
        >
          {opacity.toFixed(2)}
        </span>
      </Box>

      {/* Movement Controls */}
      <Box style={{ marginTop: '20px' }}>
        <label style={{ fontWeight: 'bold', color: '#333' }}>
          {t('review.movement')}:
        </label>
        <button
          onClick={handleMoveUp}
          style={{
            marginLeft: '10px',
            padding: '5px',
            fontSize: '12px',
            backgroundColor: '#64b5f6  ',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
            border: 'none',
            transition: 'background-color 0.3s ease'
          }}
        >
          <ArrowUpward />
        </button>
        <button
          onClick={handleMoveDown}
          style={{
            marginLeft: '5px',
            padding: '5px',
            fontSize: '12px',
            backgroundColor: '#64b5f6  ',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
            border: 'none',
            transition: 'background-color 0.3s ease'
          }}
        >
          <ArrowDownward />
        </button>
        <button
          onClick={handleMoveLeft}
          style={{
            marginLeft: '10px',
            padding: '5px',
            fontSize: '12px',
            backgroundColor: '#64b5f6  ',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
            border: 'none',
            transition: 'background-color 0.3s ease'
          }}
        >
          <ArrowBack />
        </button>
        <button
          onClick={handleMoveRight}
          style={{
            marginLeft: '5px',
            padding: '5px',
            fontSize: '12px',
            backgroundColor: '#64b5f6  ',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
            border: 'none',
            transition: 'background-color 0.3s ease'
          }}
        >
          <ArrowForward />
        </button>
      </Box>

      <Box style={{ marginTop: '20px', textAlign: 'center' }}>
        {currentTab === 0 && (
          <Button
            variant="contained"
            startIcon={<ClearAllIcon />}
            sx={{
              backgroundColor: '#e0e0e0',
              color: '#333',
              '&:hover': {
                backgroundColor: '#bdbdbd'
              },
              borderRadius: '8px',
              padding: '10px 20px',
              width: '100%'
            }}
            onClick={clearAllCheckboxes}
          >
            {t('review.clearAll')}
          </Button>
        )}
      </Box>

      {/* Points Section */}
      <Box
        style={{
          marginTop: '20px',
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          padding: '15px',
          borderRadius: '8px',
          color: '#333'
        }}
      >
        <p>
          <strong>{t('review.db_points')}:</strong> {studentData.point_sum}
        </p>
      </Box>

      <Box
        style={{
          marginTop: '20px',
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          padding: '15px',
          borderRadius: '8px',
          color: '#333'
        }}
      >
        <p>
          <strong>{t('review.points')}:</strong> {points}
        </p>
      </Box>

      <Box style={{ marginTop: '20px' }}>
        {currentTab === 1 ? (
          <button
            onClick={() => setOpenConfirmDialog(true)} // Ovaj popup će se otvoriti
            style={{
              padding: '12px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            {t('review.resetReview')}
          </button>
        ) : (
          <button
            onClick={handleSave}
            style={{
              padding: '12px 20px',
              fontSize: '16px',
              backgroundColor: '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            {t('review.confirmReview')}
          </button>
        )}
      </Box>
    </Paper>
  );
};

export default StudentInfoBox;
